import * as React from 'react'
import { Grid } from '@mds/mds-reactjs-library'
import Error from '../components/Error'
import ViewLayout, { classes } from '../components/ViewLayout'
import { ForbiddenAccessIcon } from '../icons'
import type { Customization } from '../types/Customization'

const title = 'Error - Invalid Session'

const defaultSolutionName = 'the solution URL'

type DefaultKeycloakErrorPageProps = {
  customization?: Customization
}

const getText = ({ customization }: DefaultKeycloakErrorPageProps) => (
  <p>
    Your authentication session is missing or has timed out,
    <br />
    or you have directly navigated to this URL.
    <br />
    Please access{' '}
    {!!customization?.enrollmentHomeUrl && !!customization?.enrollmentTeamName ? (
      <a href={customization.enrollmentHomeUrl}>{customization.enrollmentTeamName}</a>
    ) : (
      defaultSolutionName
    )}{' '}
    and try to log in again.
  </p>
)

const DefaultKeycloakErrorPage = ({ customization }: DefaultKeycloakErrorPageProps): JSX.Element => {
  return (
    <ViewLayout>
      <section className={classes.wrappingBox}>
        <Grid item span={12}>
          <Error icon={<ForbiddenAccessIcon />} title={title} text={getText({ customization })} />
        </Grid>
      </section>
    </ViewLayout>
  )
}

export default DefaultKeycloakErrorPage
